import { CommonChapter, CommonSkillField, CommonStudent } from '@codidae/common-types';
import Button from 'components/button/button';
import FieldCard from 'components/field-card/field-card';
import Flex from 'components/flex/flex';
import Loader from 'components/loader/loader';
import { FaCheck } from 'react-icons/fa';
import { GiCancel } from 'react-icons/gi';

export default function SelectFields({
  selectedFields,
  setSelectedFields,
  child,
  chapters,
  fields,
  onCancel,
  onSelect,
  selectLoading,
}: {
  selectedFields: number[];
  setSelectedFields: (sf: number[]) => void;
  child?: CommonStudent;
  chapters?: CommonChapter[];
  fields?: CommonSkillField[];
  onCancel: VoidFunction;
  onSelect: VoidFunction;
  selectLoading?: boolean;
}) {
  return (
    <Flex
      direction="column"
      gap={15}
      pad={20}
      width="100%"
      style={{
        overflowY: 'auto',
        flexGrow: 1,
      }}
    >
      <div
        style={{
          textAlign: 'center',
          width: '90%',
          margin: 'auto',
          fontSize: 19,
          fontWeight: 600,
          color: '#1b0d54',
        }}
      >
        Choix des matières travaillées par {child?.firstname ?? 'votre enfant'}
      </div>
      <div
        style={{
          textAlign: 'center',
          width: '100%',
          fontSize: 15,
          fontWeight: 400,
          color: '#1b0d54',
          marginTop: -10,
          marginBottom: 10,
        }}
      >
        {child?.cycle?.name} - <b>{selectedFields.length}</b> matières sélectionnées
      </div>

      {!chapters ||
        (!fields && (
          <Flex justify="center" align="center" width="100%">
            <Loader />
          </Flex>
        ))}
      <Flex
        width="100%"
        gap={20}
        style={{
          borderBottom: 'solid 2px var(--primary300)',
          paddingBottom: 20,
        }}
      >
        <Button color="red" onClick={onCancel}>
          <GiCancel /> ANNULER
        </Button>
        <Button loading={selectLoading} color="green" onClick={onSelect}>
          <FaCheck /> CONFIRMER
        </Button>
      </Flex>
      {chapters &&
        fields
          ?.filter((c) =>
            chapters.some(
              (chapter) =>
                chapter.field.id === c.id &&
                chapter.parent === null &&
                chapter.cycles?.some((cycle) => cycle.id === child?.cycle?.id),
            ),
          )
          .map((field) => (
            <FieldCard
              key={field.id}
              field={field}
              selected={selectedFields.includes(field.id)}
              toggleSelect={() => {
                const newFields = [...selectedFields];
                if (newFields.includes(field.id)) {
                  newFields.splice(newFields.indexOf(field.id), 1);
                } else {
                  newFields.push(field.id);
                }

                setSelectedFields(newFields);
              }}
            />
          ))}
    </Flex>
  );
}
